import { createAction } from '@ngrx/store';

export const InitializeApp = createAction(
  '[AppComponent] Initialize App'
);
